import { useContext, createContext, useState, useEffect } from "react";
import React from "react";
const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [changes, setChanges] = useState(0);
  const [user, setUser] = useState(() => {
    return JSON.parse(localStorage.getItem("user")) || null;
  });
  const [token, setToken] = useState(() => {
    return localStorage.getItem("token") || null;
  });
  const login = (token, User) => {
    setToken(token);
    setUser(User);
    localStorage.setItem("token", token);
    localStorage.setItem("user", JSON.stringify(User));
  };
  const logout = () => {
    console.log("logout");
    setToken(null);
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  };
  const [clientName, setClientName] = useState("Mariposa");

  useEffect(() => {
    if (localStorage.getItem("token")) {
      setToken(localStorage.getItem("token"));
    }
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, []);
  return (
    <AppContext.Provider
      value={{
        changes,
        setChanges,
        user,
        setUser,
        clientName,
        setClientName,
        login,
        logout,
        token,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = () => useContext(AppContext);
